import React, { useMemo, useState, useCallback } from 'react';

import {
	TranslatedString,
	LocallySortedAndPaginatedTable,
	makeLocallySortedAndPaginatedTableColumnHeader,
	useAjax,
	XhrStatus,
	PrimaryButton,
	Card,
	Form,
	SearchField
} from '@bosch/bt-ui';

import './UserManagementPage.css';
import withErrorHandler from '../../components/ErrorHandler';
import RestfulCallout from '../../components/RestfulCallout';
import RestfulCallLoading from '../../components/RestfulCallLoading';
import { useNavigate } from 'react-router-dom';
import { prepareLogData } from '../../components/Util';

const TABLE_HEADERS = [
	makeLocallySortedAndPaginatedTableColumnHeader('company-name', 'Company Name'),
	makeLocallySortedAndPaginatedTableColumnHeader('company-sap-number', 'Company Sap Number'),
	makeLocallySortedAndPaginatedTableColumnHeader('remote-id', 'Remote ID'), 
	makeLocallySortedAndPaginatedTableColumnHeader('role', 'Role'), 
];

function makeRow(task) {
	const {
		companyName,
		companySapNumber,
		remoteId,
		role
	} = task;

	return {
		key: companyName,
		columns: [
			{
				key: 'company-name',
				columnContent: companyName
			},
			{
				key: 'company-sap-number',
				columnContent: companySapNumber
			},
			{
				key: 'remote-id',
				columnContent: remoteId
			},
			{
				key: 'role',
				columnContent: role
			}
		]
	};
}

const UserManagementPage = (props) => {
	const {
		token,
		isLoggedIn
	} = props;
	const [ returnResult, statusc, runAjaxInner, responsec] = useAjax(XhrStatus.Initial);
	const [searchEmail, setSearchText] = useState('');
	const [errorState, setErrorState] = useState(false);
	const [searchErrorMessage, setSearchErrorMessage] = useState('');
	const [result, status, getUserCompanyInfo, response] = useAjax(XhrStatus.Initial);
	const navigate = useNavigate();
	const [currentPage, setCurrentPage] = useState(1);

	const onFormSubmit = useCallback(
		() => {
			const data = prepareLogData(token,'User_Management', 'User Management-> Search: ' + searchEmail);

			// If useAjax(XhrStatus.InProgress) and not login yet, it will show 401
			// So we need to make sure token is avaliable to continue...
			if (token?.token) {
				if(isLoggedIn()) {
					setErrorState(true);
					if (searchEmail)
					{
						if (searchErrorMessage == null)
						{
							setCurrentPage(1);
							getUserCompanyInfo('GET', SUPPORTCONSOLE_API_URL + '/api/usermanagement/v1/usermanagement/' + encodeURIComponent(searchEmail), null, undefined, { 'Authorization': 'Bearer ' + token.token });
							//Add activity log
							fetch(SUPPORTCONSOLE_API_URL + '/api/activity/v1/activitylog', {
								method: 'POST',
								headers: {
								'Content-Type': 'application/json',
								'Authorization': 'Bearer ' + token.token
								},
								body: JSON.stringify(data)
							})	
						}
					}
				}
				else {
					navigate('/');
				}
			}
		},
		[searchEmail, searchErrorMessage, token.token, getUserCompanyInfo, isLoggedIn, navigate]
	);
	
	const rows = useMemo(
		() => {
			console.log(result);

			const allRows = (result?.data) ? result.data.map(item => makeRow(item)) : [];
			return allRows;
		},
		[result]
	);

	return (
		<Card
			htmlAttributes={{
				id: 'user-management-page'
			}}
		>
			<RestfulCallout status={status} response={response} returnObj={result} hideSuccess={true} />
			<div className="form-input">
				<Form
					formAttributes={{
						onSubmit: onFormSubmit,
						method: 'get',
						action: ''
					}}
				>
					<SearchField
						type="input"
						fieldName="search"
						shouldAlwaysShowErrors={errorState}
						validationError={searchErrorMessage}
						onValidationError={(update) => {
							setSearchErrorMessage(update.value);

						}}
						htmlAttributes={{
							onChange: update => setSearchText(update.value),
							value: searchEmail,
							placeholder: 'Email Address',
							required: true,
							pattern: '[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$',
							title: 'Email is invalid'
						}}
					/>
					<PrimaryButton type="submit">Search</PrimaryButton>
				</Form>
			</div>
			{
				< LocallySortedAndPaginatedTable
					headers={TABLE_HEADERS}
					rows={rows}
					numRowsPerPage={50}
					currentPage={currentPage}
					goToPageFunc={setCurrentPage}
					htmlAttributes={{
						className: 'user-management-table'
					}}
					errorMessage="Error occured"
					noResultsMessage={<TranslatedString stringId="No items found" />}
					defaultSortColumn="company-name"
					defaultSortDirection="asc"
				/>
			}
			<RestfulCallLoading status={status} />
		</Card>
	);
};

export default withErrorHandler(React.memo(UserManagementPage));